var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-adopt-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-86553d26!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-adopt-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeAdoptList.vue
// module id = 1327
// module chunks = 1